module.exports = __webpack_public_path__ + "img/AssetManager-dark.5bc589af.svg";